var stateManager = require('../state/stateManager.js');
var stringUtil = require('../string/stringUtil.js');
var validator = require('../validator/validator.js');
var formatter = require('../formatter/formatter.js');

module.exports.getProperty = function()
{
    return stateManager.getStore().getState().orgData.property;
}

module.exports.getPropertyStorefronts = function()
{
    var storefronts = this.getProperty().storefronts;
    if (storefronts == null)
        storefronts = [];

    return storefronts;
}

module.exports.getStorefrontById = function (storefrontId)
{
    const storefront = this.getPropertyStorefronts().find(sf => stringUtil.areStringSame(sf.id, storefrontId));
    return storefront;
}

module.exports.getPropertyOperatingConfiguration = function()
{
    return this.getProperty().operatingConfiguration; 
}

module.exports.getFranchisorOperatingConfiguration = function()
{
    return this.getFranchisor().operatingConfiguration; 
}

module.exports.getPropertyPrintConfiguration = function()
{
    return this.getProperty().printConfiguration; 
}

module.exports.getPropertySubscriptions = function()
{
    return this.getProperty().subscriptions; 
}

module.exports.getPropertyResolvedLocationSettings = function()
{
    return this.getProperty().resolvedLocalizationSettings; 
}

module.exports.getDistanceMeasurementSystem = function()
{
    return this.getPropertyResolvedLocationSettings().distanceMeasurementSystem;
}

module.exports.getDistanceMeasurementUnit = function()
{
    return this.getDistanceMeasurementSystem() === "imperial" ? "miles" : "kms";
}

module.exports.getPropertyFloatConfiguration = function()
{
    return this.getProperty().floatConfiguration; 
}

module.exports.getFranchisee = function()
{
    return stateManager.getStore().getState().orgData.franchisee;
}

module.exports.getFranchisor = function()
{
    return stateManager.getStore().getState().orgData.franchisor;
}

module.exports.getVenues = function()
{
    return stateManager.getStore().getState().lookupData.venues;
}

module.exports.getCourseNames = function()
{
    return stateManager.getStore().getState().lookupData.courseNames;
}

module.exports.getTodaySales = function ()
{
    return stateManager.getStore().getState().todaySales;
}

module.exports.getPrintingTemplates = function()
{
    return stateManager.getStore().getState().printingTemplates;
}

module.exports.getFreebieReasons = function()
{
    return stateManager.getStore().getState().lookupData.freebieReasons;
}

module.exports.getGuests = function()
{
    return stateManager.getStore().getState().lookupData.guests;
}

module.exports.isModuleSubscribed = function(moduleName)
{
    if (this.getPropertySubscriptions() == null || this.getPropertySubscriptions().length <= 0)
        return false;

    return this.getPropertySubscriptions().find(s => stringUtil.areStringSame(s.moduleName, moduleName)) != null;
}

module.exports.convertDistanceToLocalUnit = function(distance)
{
    if (stringUtil.isStringNullOrEmpty(distance) || !validator.isNumeric(distance))
        return "";
    if(this.getDistanceMeasurementUnit() === "kms")
        return formatter.roundUp(distance * 1.60934, 1);
    return distance;
}
